/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ReleaseDeliverablesList_stateTypes$ref: FragmentReference;
declare export opaque type ReleaseDeliverablesList_stateTypes$fragmentType: ReleaseDeliverablesList_stateTypes$ref;
export type ReleaseDeliverablesList_stateTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: ReleaseDeliverablesList_stateTypes$ref,
|};
export type ReleaseDeliverablesList_stateTypes$data = ReleaseDeliverablesList_stateTypes;
export type ReleaseDeliverablesList_stateTypes$key = {
  +$data?: ReleaseDeliverablesList_stateTypes$data,
  +$fragmentRefs: ReleaseDeliverablesList_stateTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ReleaseDeliverablesList_stateTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ea85c54e4fb5a845796ca344fa457cf9';
module.exports = node;
